import {
	POSITION_SETS,
	STORY_SCALES,
	getPreviewMediaId,
} from './storyBar.constants';
import { getMediaFileId } from './getMediaFileId';
import { inferStoryMediaType } from './inferStoryMediaType';

export const buildStoriesForPerson = (person, personIdx) => {
	const images = person.stories_images || [];
	const positionSet = POSITION_SETS[personIdx % POSITION_SETS.length];
	const storyCount = images.length;
	const profileMediaId = getMediaFileId(person.profile_image);

	if (storyCount === 0) {
		return [{
			personId: person._id || person.id,
			person,
			media: person.profile_image,
			mediaId: profileMediaId,
			type: 'image',
			previewMediaId: profileMediaId,
			position: positionSet[0],
			scale: STORY_SCALES[0],
			storyNumber: 1,
			storyCount: 1,
		}];
	}

	const imageItems = images.map((image, imgIdx) => {
		const mediaType = inferStoryMediaType(image, person);

		return {
			personId: person._id || person.id,
			person,
			media: image,
			mediaId: getMediaFileId(image),
			type: mediaType,
			previewMediaId: getPreviewMediaId(person, image, mediaType),
			position: positionSet[imgIdx % positionSet.length],
			scale: STORY_SCALES[imgIdx % STORY_SCALES.length] || 1.08,
			storyNumber: imgIdx + 1,
			storyCount,
		};
	});

	return imageItems;
};

export const buildStoryPersons = (persons) => {
	return persons.map((person, personIdx) => {
		const stories = buildStoriesForPerson(person, personIdx);

		return {
			personId: person._id || person.id,
			person,
			stories,
			peekItem: stories[0],
		};
	});
};
